import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { type DefaultProps } from '../common'

export const Logo: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  const finalClasses = twMerge('fill-black', className)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={118}
      width={80}
      viewBox="0 0 80 118"
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      aria-hidden="true"
    >
      <path d="M0,118.04V0h73.17l6.83,19.43H22.56v29.64h40.54l6.65,19.43H22.56v30.01h50.79l6.65,19.43H0v.09Z" />
    </svg>
  )
}
